// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__ieEQs","content":"Page_content__37PT5","scrollingDisabled":"Page_scrollingDisabled__29kSq"};